import styled from '@emotion/styled';

export const ListTextarea = styled.textarea`
  border: 0.5px solid gray;
  padding: 3px;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  font-size: 14px;
`;

export const StyledLi = styled.li<{ checkbox?: boolean }>`
  display: ${props => (props.checkbox ? 'flex' : 'block')};
  align-items: center;
`;

export const StickySearchWrapper = styled.div`
  position: sticky;
  background-color: #fff;
  z-index: 99;
  top: 0;
  right: 0;
  padding: 22px 0 8px;
`;

export const SearchBar = styled.input`
  padding: 8px;
  border: 1px solid gray;
  width: 100%;
`;

export const ListLabel = styled.label<{ checkbox?: boolean }>`
  overflow: hidden;
  overflow-wrap: break-word;
  cursor: ${props => (props.checkbox ? 'pointer' : '')};
  font-size: 14px;
  font-weight: 600;
  color: #46494a;
`;
